<template>
  <!-- :theme="themeStore.theme" -->
  <!-- :class="themeStore.theme" -->
  <wd-config-provider class="bg-page-bg" :themeVars="themeVars">
    <slot />
    <CustomTabbar />
    <wd-toast />
    <wd-message-box />
  </wd-config-provider>
</template>

<script lang="ts" setup>
import type { ConfigProviderThemeVars } from 'wot-design-uni'
import CustomTabbar from '@/components/CustomTabbar/index.vue'
// import { useThemeStore } from '@/store'

// const themeStore = useThemeStore()

const themeVars: ConfigProviderThemeVars = {
  // colorTheme: 'red',
  // buttonPrimaryBgColor: '#07c160',
  // buttonPrimaryColor: '#07c160',
}
</script>
